import { Statistic, StatisticProps } from "antd"
import CountUp from 'react-countup';

export interface IStatistic {
    name: string,
    value: number
}
export const StatisticView = (props:{ stat: IStatistic})=>{

    const formatter: StatisticProps['formatter'] = (value) => (
        <CountUp end={value as number} separator="," />
      );
      
    return (
        <>
        <Statistic title={props.stat.name} value={props.stat.value} formatter={formatter} />
        </>
    )
}